module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-Australia-Website-w540.800e09fe.webp";